import { color, Common, device } from '@stockbit/ui';
import styled, { css } from 'styled-components';

const { IconWrapper, Flex, Text } = Common;

const ButtonIcon = styled(IconWrapper)`
  display: none;
  @media ${device.tablet} {
    display: block;
  }
`;

const ButtonText = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  display: block;
  color: ${color.midgray};
  font-size: 12px;
  @media ${device.tablet} {
    display: none;
  }
`;

const FooterMobile = styled(Flex)`
  display: flex;
  @media ${device.tablet} {
    display: none;
  }
`;

const FooterWeb = styled(Flex)`
  display: none;
  margin-top: 15px;
  @media ${device.tablet} {
    display: flex;
  }
`;

const Separator = styled.em`
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  padding: 0 4px;
  color: #b5b5b5;
`;

const HeaderContent = styled(Flex).attrs({ justify: 'space-between' })`
  width: 100%;
  margin-left: 10px;
`;
const TextHeader = styled(Text).attrs({ as: 'a' })`
  &:hover {
    color: inherit;
  }

  ${({ color: textColor }) =>
    textColor &&
    css`
      &:hover {
        color: ${textColor};
      }
    `}
`;

const TextDate = styled(Text).attrs({ as: 'a' })`
  display: none;
  @media ${device.tablet} {
    display: block;
  }
`;

const CommentLimitInfoContainer = styled(Flex).attrs({
  align: 'center',
})`
  background: #F7F7F7; // TODO: Add color to stockbit/ui
  padding: 12px 20px;
  margin-top: 20px;

  img {
    margin-right: 10px;
  }
`;

export {
  ButtonIcon,
  ButtonText,
  FooterMobile,
  FooterWeb,
  Separator,
  HeaderContent,
  TextHeader,
  TextDate,
  CommentLimitInfoContainer,
};
